import {constructPartnerBillingDetails} from "../Factory/factory";
import {findPartnerBilling} from "../Util/queries";

const PARTNER_BILLING = "PARTNER_BILLING"

export const getPartnerBillingDetails = () =>
    async (dispatch) => {
        try {
            let response = await findPartnerBilling();
            if (response.data) {
                let partnerBillingDetailsObj = constructPartnerBillingDetails(response.data);
                dispatch({
                    type: PARTNER_BILLING,
                    payload: partnerBillingDetailsObj
                })
            } else {
                dispatch({
                    type: PARTNER_BILLING,
                    payload: null
                })
            }
        } catch (e) {
            console.error(e)
            dispatch({
                type: PARTNER_BILLING,
                payload: null
            })
        }
    }

export {PARTNER_BILLING}